import axios from 'axios';
import vars from 'vars';

export const changePasswordPublicGateway = (request) => {
  return axios
    .patch(`${vars.REACT_APP_API_URL}/api/v1/change-password`, request, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((exception) => {
      const responseData = exception?.response?.data;
      const apiError = exception?.response?.data?.error;
      if (apiError && typeof apiError === 'object') {
        return Promise.reject({
          status: exception?.response?.status,
          code: apiError.code,
          message: apiError.message,
          details: apiError.details || {},
          responseData,
        });
      }
      return Promise.reject({
        status: exception?.response?.status,
        code: exception?.code,
        message: exception?.response?.data?.message || exception?.message,
        details: {},
        responseData,
      });
    });
};

